import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-waiting',
  imports: [TranslateModule],
  templateUrl: './waiting.html',
  styleUrl: './waiting.scss',
})
export class Waiting {
  @Input() message: string = '';
}
